// qs-brushes-registry.ts
import type { BaseBrush } from '@/brushes/base/qs-brushes-base'
import type { BrushType } from '@/types/qs-types-index'

class BrushRegistry {
  private readonly brushes = new Map<string, BaseBrush>()
  private readonly brushTypes = new Map<BrushType, string>()

  register(brush: BaseBrush): void {
    this.brushes.set(brush.config.id, brush)
  }

  setBrushTypeMapping(brushType: BrushType, brushId: string): void {
    this.brushTypes.set(brushType, brushId)
  }

  getBrush(id: string): BaseBrush | undefined {
    return this.brushes.get(id)
  }

  getAllBrushes(): readonly BaseBrush[] {
    return Array.from(this.brushes.values())
  }

  getBrushesByCategory(category: string): readonly BaseBrush[] {
    const result: BaseBrush[] = []
    for (const brush of this.brushes.values()) {
      if (brush.config.category === category) {
        result.push(brush)
      }
    }
    return result
  }

  mapBrushType(brushType: BrushType): string {
    return this.brushTypes.get(brushType) ?? 'round'
  }

  getBrushByType(brushType: BrushType): BaseBrush | undefined {
    const brushId = this.mapBrushType(brushType)
    return this.getBrush(brushId)
  }

  hasBrush(id: string): boolean {
    return this.brushes.has(id)
  }

  getBrushCount(): number {
    return this.brushes.size
  }
}

export const brushRegistry = new BrushRegistry()